export default defineNuxtRouteMiddleware((to) => {
  const productKeys = Object.keys(PagesContentTypeQuery).filter((k) => k.endsWith("_prod"))

  if (productKeys.some((k) => k.startsWith(to.params.productId as string))) return

  return navigateTo("/")
})
